module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-bin-red@2x-d56afd3f50a65069af4c0aeb24becd8b.png";